<template>
  <component :is="tag" class="badge" :class="classes"><slot /></component>
</template>

<script>
export default {
  name: "Badge",
  props: {
    tag: {
      type: String,
      default: "span",
    },
    size: {
      type: String,
      default: "medium",
      validator: (value) => {
        return ["small", "medium", "large"].includes(value);
      },
    },
    theme: {
      type: String,
      default: "primary",
      validator: (value) => {
        return ["primary", "highlight", "disabled"].includes(value);
      },
    },
  },
  computed: {
    classes() {
      return {
        "badge--small": this.size === "small",
        "badge--large": this.size === "large",
        "badge--highlight": this.theme === "highlight",
        "badge--disabled": this.theme === "disabled",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.badge {
  color: $color-black;
  @include utility-label(12px);
  padding: 4px 6px;
  background-color: $color-white;
  border-radius: 8px;
  color: $color-green;
  font-weight: 700;

  &--small {
    @include utility-label(10px);
    text-transform: supercase;
  }
  &--highlight {
    color: $color-red;
  }
  &--disabled {
    color: $color-grey-dark;
    opacity: 0.5;
  }
}
</style>
